(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesDeleteController', TabFilesDeleteController);

    TabFilesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabFiles'];

    function TabFilesDeleteController($uibModalInstance, entity, TabFiles) {
        var vm = this;
        vm.tabFiles = entity;

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabFiles.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
